import EditLocationOutlinedIcon from '@mui/icons-material/EditLocationOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import {FormControlLabel, MenuItem, Switch} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {SnapshotMenuButton} from './snapshot.styles.jsx';

const FormControl = props => (
  <FormControlLabel
    labelPlacement="start"
    control={<Switch color="primary" sx={{marginLeft: 0.5}} />}
    slotProps={{
      typography: {
        variant: 'body2',
      },
    }}
    {...props}
  />
);
const OverlayOptionsMenu = props => {
  const {t} = useTranslation();

  const handleChange = event => {
    props.onChange(event.target.name);
  };

  return (
    <SnapshotMenuButton
      label={<EditLocationOutlinedIcon />}
      tooltipTitle={t('snapshot.tooltipOverlayMenu')}
      data-qe="snapshot-overlay-options"
    >
      <MenuItem dense divider>
        <FormControl
          label={t('snapshot.toggleShowDate')}
          onChange={handleChange}
          name="dates"
          checked={props.options.dates}
        />
      </MenuItem>
      <MenuItem dense divider>
        <FormControl
          label={t('snapshot.toggleShowCoordinates')}
          onChange={handleChange}
          name="coords"
          checked={props.options.coords}
        />
      </MenuItem>
      <MenuItem dense>
        <FormControl
          label={t('snapshot.toggleShowMinimap')}
          onChange={handleChange}
          name="minimap"
          checked={props.options.minimap}
        />
      </MenuItem>
    </SnapshotMenuButton>
  );
};

OverlayOptionsMenu.propTypes = {
  options: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OverlayOptionsMenu;
